(function () {
  angular.module("akitabox.ui.dialogs.qrCode", [
    "akitabox.ui.dialogs.qrCode.associate",
    "akitabox.ui.dialogs.qrCode.manualEntry",
    "akitabox.ui.dialogs.qrCode.pinSearch",
  ]);
})();
